import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import TarjetaServicio from "./TarjetaServicio/TarjetaServicio";
import "./servicio.css";

const Servicios = forwardRef((props, ref) => {
  const { t } = useTranslation();
  return (
    <div className='servicios' id="servicios" ref={ref}>
      <h1 className='textoServicio'>{t('Servicios.titulo')}</h1>
      <div className='cajaServicios'>
        <TarjetaServicio
          img="img/servicios-tarjetas/holistico.webp"
          id={1}
          alt={t('Servicios.alt1')}
          nombre={t('Servicios.nombre1')}
          descripcion={t('Servicios.descripcion1')}
          link={'/TerapiasHolisticas'}
        />
        <TarjetaServicio
          img="img/servicios-tarjetas/masajes.webp"
          id={2}
          alt={t('Servicios.alt1')}
          nombre={t('Servicios.nombre2')}
          descripcion={t('Servicios.descripcion2')}
          link={'/MasajesAyurvedicos'}
        />
        <TarjetaServicio
          img="img/servicios-tarjetas/coach.webp"
          id={3}
          alt={t('Servicios.alt1')}
          nombre={t('Servicios.nombre3')}
          descripcion={t('Servicios.descripcion3')}
          link={'/VistaDetallada/13'}
        />
      </div>
    </div>
  );
});
export default Servicios;